import React from 'react';


import Animation from "../animation/animation";
import Card from "../card/card";
import ContactFormRu from "../contact-form/contact-form-ru";
import Grid from "../grid/grid";
import GridLine from "../grid-line/grid-line";

import './services.scss';

import urbanVideo from '../../f/videos/urban.mp4';
import urbanCover from '../../f/img/urban.jpg';

import retailVideo from '../../f/videos/retail.mp4';
import retailPoster from '../../f/img/retail.png';

import sportVideo from '../../f/videos/sport.mp4';
import sportPoster from '../../f/img/sport.png';

import fmcgVideo from '../../f/videos/fmcg.mp4';
import fmcgPoster from '../../f/img/fmcg.png';

import industryVideo from '../../f/videos/industry.mp4';
import industryPoster from '../../f/img/industry.png';

import realVideo from '../../f/videos/real.mp4';
import realPoster from '../../f/img/real.jpg';

const ServicesRu = () => {
  return (
    <React.Fragment>
      <div className="services category-list">
        <div className="services-header">
          <h1 className="services-header__text">Competencies</h1>

          <div className='services-header__link-list'>
            <a className='services-header__link' href='/competencies'>What We Do</a>
            <div className='services-header__link active-link'>For Whom</div>
          </div>

          <Animation header="aйдентика, архитектура, веб, видео, графдизайн, городская среда, иллюстрации, интерьеры, интерфейсы, книги, логотипы, мобильные приложения, моушн-дизайн, навигация, паттерны, презентации, промдизайн, реклама, шрифты, экстерьеры" />

          <div className="als-text-container">
            <p className="services__text">
              For each industry, there is its own set of solutions, proven by hundreds of projects: from strategy and branding to navigation and architecture.
            </p>
          </div>
        </div>
        <div className="services-main">
          <Grid>
            <GridLine>
              <Card
                url="/competencies/target/urban"
                type="video"
                previewContent={urbanVideo}
                poster={urbanCover}
                title="Design for cities"
                description="Design that makes cities recognizable and convenient. From strategy and branding to navigation and architecture."
              />
              <Card
                url="/competencies/target/retail"
                type="video"
                previewContent={retailVideo}
                poster={retailPoster}
                title="Design for retail"
                description="We help brands talk about themselves vividly and convincingly in any environment and communication: online, in print, on a facade or a store shelf."
              />
              <Card
                url="/competencies/target/sport"
                type="video"
                previewContent={sportVideo}
                poster={sportPoster}
                title="Design for sports"
                description="We inspire athletes to win and awaken hidden emotions in fans. We create team brands, design sports spaces and shape entire visual systems."
              />
              <Card
                url="/competencies/target/fmcg"
                type="video"
                previewContent={fmcgVideo}
                poster={fmcgPoster}
                title="Design for fast-moving consumer goods"
                description="We create a product image that is noticed on shelves, carefully examined and eventually bought. Every day."
              />
              <Card
                url="/competencies/target/industry"
                type="video"
                previewContent={industryVideo}
                poster={industryPoster}
                title="Design for industry"
                description="We help powerful industrial enterprises become closer to people: we vividly present their activities and products, improve working conditions for employees, and solve internal and external communication tasks."
              />
              <Card
                url="/competencies/target/real-estate"
                type="video"
                previewContent={realVideo}
                poster={realPoster}
                title="Design for Real Estate"
                description="We enjoy working with developers on real estate projects: designing facades, creating art installations, developing interiors, and enhancing surrounding areas. With our help, every project gains its own identity and expresses a unique character."
              />

            </GridLine>
          </Grid>
        </div>
        <ContactFormRu formId="другое" />
      </div>
    </React.Fragment>
  );
}

export default ServicesRu;
